import { injectGlobal } from 'styled-components';

require('./fonts.css');

import colours from './colours';
import grid from './grid';
import fonts from './fonts';
import spacing from './spacing';
import styles from './styles';
import states from './states';
import { remCalc } from '@lux/helpers';
import mediaQueries from '../helpers/mediaQueries';

// Inject global CSS required to use this component library
injectGlobal`
  .lux-component-container {
    ${fonts.styles.BodyCopy};

    line-height: 1.6;
    letter-spacing: 0.16px;
    text-size-adjust: 100%;

    box-sizing: border-box;
    *, *:before, *:after {
      box-sizing: inherit;
    }

    hr {
      border: solid ${colours.grey_dd};
      border-width: 1px 0 0;
      clear: both;
      height: 0;
      margin: ${remCalc(20)} 0;
    }
  }

`;

export default {
  colours: colours,
  fonts: fonts,
  spacing: spacing,
  media: mediaQueries(grid.breakpoints),
  styles: styles,
  grid: grid,
  states: states
};
